export default "__VITE_ASSET__xaBZNp0R__"